import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { stripHtml } from "core/utils/string";

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3, 2, 6),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(3, 3, 6),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ShortyContentInfoDialog({ content, open, onClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation("arena");

  if (!content) return null;

  return (
    <Dialog
      fullWidth
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      maxWidth="md"
      open={open}
      onClose={onClose}
    >
      <AppBar position="static" color="default">
        <Toolbar>
          <Typography variant="h5" style={{ flex: 1 }}>
            {t("contentInfo.title")}
          </Typography>
          <IconButton edge="end" onClick={onClose} size="large">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <StyledDialogContent>
        <Box>
          {/* Заголовок */}
          <Typography
            variant="h4"
            component="h1"
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: theme.palette.text.primary,
            }}
          >
            {stripHtml(content.title)}
          </Typography>

          {/* Описание */}
          {content.description && (
            <Typography
              variant="body1"
              sx={{
                mb: 3,
                lineHeight: 1.6,
                color: theme.palette.text.primary,
                whiteSpace: "pre-wrap",
              }}
            >
              {stripHtml(content.description)}
            </Typography>
          )}
        </Box>
      </StyledDialogContent>
    </Dialog>
  );
}

ShortyContentInfoDialog.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    sport: PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
    }),
    league: PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
    }),
    teams: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    date: PropTypes.string,
  }),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
